import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'sc-weather-info-sheet',
  styleUrls: ['./weather-info-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="container">
      <div class="close-icon-container">
        <button (click)="onClose()">
          <sc-icon name="close"></sc-icon>
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeDialog'
              | translate
                : {
                    dialogTitle: 'WeatherInfoSheet.dialogTitle' | translate
                  }
          }}</span>
        </button>
      </div>

      <h1 mat-dialog-title id="weather-info-title-id" class="sr_only">
        {{ 'WeatherInfoSheet.dialogTitle' | translate }}
      </h1>

      <div class="big-icon-container">
        <span class="icon-back-circle">
          <sc-icon name="info"></sc-icon>
        </span>
      </div>
      <div class="main-infos">
        <p>{{ 'WeatherInfoSheet.ruleInfo' | translate }}</p>
      </div>
      <sc-button (click)="onClose()">{{
        'WeatherInfoSheet.buttonLabel' | translate
      }}</sc-button>
    </div>
  `,
  imports: [IconComponent, ButtonComponent, TranslateModule],
})
export class WeatherInfoSheetComponent {
  @Output() closeEvent = new EventEmitter<void>();

  onClose() {
    this.closeEvent.emit();
  }
}
